import { MovieOpenCogIcon } from './MovieOpenCogIcon';

/**
 * author: Colton Wiscombe
 * id 20ADB8D7-DA55-463B-A523-9FA0377A1C74
 * name movie-open-cog
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-cog.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const ClapperboardOpenCogIcon = MovieOpenCogIcon;
export default ClapperboardOpenCogIcon